import { https } from '../http';
import { showError, showSuccess } from '../utils';

const getSmsConsent = async (userId) => {
  try {
    const url = userId ? `/auth/sms-consent/${userId}` : '/auth/sms-consent';
    const response = await https().get(url);
    if (response?.status === 200) return response.data;
  } catch (error) {
    showError(error?.response?.data?.message || 'Failed to load communication preferences');
  }
  return null;
};

const updateSmsConsent = async ({ smsOptIn, emailOptIn }, userId) => {
  try {
    const url = userId ? `/auth/sms-consent/${userId}` : '/auth/sms-consent';
    const response = await https().patch(url, { smsOptIn, emailOptIn });
    if (response?.status === 200) {
      showSuccess('Communication preferences saved');
      return response.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message || 'Failed to update communication preferences');
  }
  return null;
};

export { getSmsConsent, updateSmsConsent };
